<ui-title [title]="'QAR Report Rejected Users'">

	<div class="col-lg-6 float-right">
		<ui-loading [loadingText]="'loading'" [loading]="rejected.loading"></ui-loading>
	</div>
</ui-title>

<div class="col-lg-6">
	<ui-table
		[chunker]="reports.chunker" (chunked)="reports.chunkedData = $event"
		[headers]="reports.tableHeaders"
	>
		<tr *ngFor="let report of reports.chunkedData"
			[class]="reports.selectedId==report.Id?'helper-clickable active':'helper-clickable'"
			(click)="onReportRowClick(report)"
		>
			<td>{{ report.Name }}</td>
			<td>{{ report.Year }}</td>
			<td class="helper-capitalize">{{ report.StatusId }}</td>
			<td>{{ report.CreatedDate|date }}</td>
			<td>{{ report.ClosedDate|date }}</td>
		</tr>
	</ui-table>
</div>

<div class="col-lg-12 mt-4 report-rejected-users" *ngIf="reports.selectedId">
	<ui-loading [loadingText]="'loading report'" [loading]="rejected.loading"></ui-loading>
	<div *ngIf="reports.selected">
		<button style=" margin-top: 5px;" mat-button class="btn-primary float-right" (click)="testAllUserAccess()">
			Check All Access - Not checked / Still Exist
		</button>
		<ui-loading [loadingText]="'loading report'" [loading]="rejected.loadingRejectedUser"></ui-loading>
		<h2>Report {{ reports.selected.Name }} {{ reports.selected.Year }}
		</h2>

		<div class="alert alert-warning" *ngIf="rejected.waitCount">There are {{ rejected.waitCount }} reports that have not yet been counter signed</div>
		<ui-table #tableRejected
				  [filters]="true"
				  [chunker]="rejected.chunker" (chunked)="rejected.chunkedData = $event"
				  [headers]="rejected.tableHeaders"
				  [options]="{downloadAsExcel:true,downloadAsExcelHeaders:downloadAsExcelHeaders,downloadAsExcelRowFormatter:downloadAsExcelRowFormatter}"
		>
			<tr *ngFor="let row of rejected.chunkedData"
			>

				<td>
					{{ row.SystemBatchRow.SystemRole.System.Name }}
				</td>
				<td>
					{{ row.SystemBatchRow.SORUser.Login }}
				</td>
				<td>
					{{ row.SystemBatchRow.SORUser.FirstName }}
					{{ row.SystemBatchRow.SORUser.LastName }}
				</td>
				<td>
					{{ row.SystemBatchRow.UserName }}
				</td>
				<td>
					{{ row.SystemBatchRow.RoleName }}
				</td>
				<td>
					{{ row.ReportParticipation.StatusId == 'counter_signed' ? 'Implement' : 'Wait' }}
					<!-- WAIT and CAN IMPLEMENT -->
				</td>
				<td style="width: 50px">
					<span style="overflow: hidden">
					{{ rejected.reasons[row.OverridenStatusId == 'rejected' ? row.OverridenRejectionReason : row.RejectionReason] }}

						{{ row.OverridenStatusId == 'rejected' ? '(overriden)' : '' }}
						</span>
				</td>

				<td>
					<a [routerLink]="'/p/reports/participation/' + row.ReportParticipation.Id">Open Report</a>
				</td>
				<td style="width: 250px">
					<ui-loading [loading]="comments.saving[row.Id]"></ui-loading>
					<input [hidden]="comments.saving[row.Id]" type="text" class="form-control " name="system_comments_{{row.Id}}" placeholder="Comments" [(ngModel)]="row.RejectedUserComments"/>
					<button [hidden]="comments.saving[row.Id]" style=" margin-top: 5px;" mat-button class="btn btn-primary float-right" (click)="comments_save(row)">
						Save
					</button>
				</td>
				<td style="width:160px;">
					<div class="form-group">
						<select [hidden]="verificationDropdown.hidden[row.Id]" name="lastStatus" id="lastCheckedStatus" class="form-control" [(ngModel)]="row.LastCheckedStatus" (change)="lastKnownStatus($event.target.value,row)">
							<option value="null">To Verify</option>

							<option *ngFor="let kv of verificationDropdown.options|kv" [value]="kv.key">{{ kv.value }}</option>
						</select>

						<div *ngIf='row.LastCheckedDate!=""' class="updated-time helper-clickable" id="{{row.SystemBatchRow.Id}}" style="line-height: 25px;"  (click)="verificationDropdown.hidden[row.Id] = false">
							<i class="material-icons green float-left" *ngIf="row.LastCheckedStatus=='done_verified'">check</i>
							{{ row.LastCheckedDate|date }}
						</div>
					</div>
				</td>

				<td>
					<ui-loading [loading]="testAccess.testing[row.Id]"></ui-loading>
					<button [hidden]="testAccess.testing[row.Id]" style=" margin-top: 5px;width:100%" class="btn btn-primary" (click)="testAccess_test(row)">
						<i class="material-icons material" style="color:#FFFFFF">rule</i>
					</button>

					<div *ngIf="testAccess.testingResult[row.SystemBatchRow.Id]">
						<b class="red" *ngIf="testAccess.testingResult[row.SystemBatchRow.Id].AccessExists">Still exists</b>
						<b class="green" *ngIf="testAccess.testingResult[row.SystemBatchRow.Id].AccessRemoved">Removed</b>
						<b class="red" *ngIf="testAccess.testingResult[row.SystemBatchRow.Id].Error">Error {{ testAccess.testingResult[row.SystemBatchRow.Id].ErrorType }}</b>
					</div>
					<span *ngIf="!testAccess.testingResult[row.SystemBatchRow.Id]" style="opacity: 0.5;">Not checked</span>
				</td>
			</tr>
		</ui-table>
	</div>
</div>
